/* Built in Imports */
import NextLink from 'next/link';
/* External Imports */
import { Box, Flex, Heading, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
/* Internal Imports */
import StructuredTextParser from '@msr/Utility/StructuredTextParser';
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import SimpleButton from '@msr/components/Buttons/SimpleButton';
import { useMediaQuery } from 'react-responsive';
/* Styles */
/* Services */
/**
 * Renders ThevaramIntroSection Component
 * @param {Object} sectionContent - dato
 * @param {string} region - region of the page
 * @param {string} lang - Language of the page
 * @returns {ReactElement} ThevaramIntroSection Component
 */

export const TwoColumnTextAndImage = ({ sectionContent, region, lang }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  if (!isMobile) {
    return (
      <>
        <Box
          //m={{ base: '10px', md: '40px', lg: '0 auto' }}
          height="auto"
          backgroundColor={'#00052F'}
          display="flex"
          flexDir="column"
          paddingTop={{ base: '35px', lg: '35px' }}
        >
          <Box
            height="auto"
            m="0 auto"
            //pb="50px"
            display="grid"
            placeItems="center"
            maxW={'1163px'}
          >
            <Flex
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
              alignItems="center"
              m={{ base: '0 20px', md: '0 20px', lg: '0' }}
            >
              <Box
                as="article"
                //maxW="540px"
                mt={{ base: '24px', md: '20px' }}
                mr={{ base: '0', md: '0', lg: '54px' }}
                maxW={lang == 'ta' ? '600px' : ''}
              >
                <Heading
                  as="h1"
                  fontStyle="normal"
                  fontWeight="600"
                  fontSize={{
                    base: lang == 'ta' ? '24px' : '38px',
                    sm: lang == 'ta' ? '24px' : '38px',
                    lg: lang == 'ta' ? '32px' : '40px',
                  }}
                  lineHeight={{ base: '45.6px', sm: '45.6px', lg: '48px' }}
                  color="#FFA735"
                  fontFamily={
                    lang == 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'
                  }
                >
                  {sectionContent[0].text}
                </Heading>
                <Heading
                  as="h3"
                  fontWeight={lang == 'ta' ? '600' : '500'}
                  fontSize={{
                    base: '24px',
                    sm: '24px',
                    lg: lang == 'ta' ? '32px' : '30px',
                  }}
                  lineHeight={{
                    base: '22.8px',
                    sm: '22.8px',
                    lg: lang == 'ta' ? '38.4px' : '28.5px',
                  }}
                  fontFamily={
                    lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-medium'
                  }
                  color={'#FFA735'}
                  mb={'-15px'}
                >
                  {sectionContent[1].text}
                </Heading>
                .
                <Text
                  as="p"
                  mt="10px"
                  fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'}
                  className="left-intro-section-text"
                  mb="-5px"
                >
                  <style>
                    {`
                .left-intro-section-text{
                  p {
                    font-weight: 400;
                    line-height: 21.6px;
                    margin-bottom:15px;
                  }
                }
                `}
                  </style>
                  <StructuredTextParser
                    str={render(sectionContent[2].body)}
                    p="0"
                    lang={lang}
                    fontSize="18px"
                    color={'#FFFFFF'}
                    pageName="tamilthembu"
                    m="0"
                  />
                </Text>
                <Box>
                  <Flex
                    flexDir={{ md: 'row', base: 'column' }}
                    alignItems={{ base: 'start', md: 'center' }}
                  >
                    <SimpleButton
                      style={sectionContent[4]}
                      region={region}
                      lang={lang}
                      mb="0"
                      mt="0"
                      fontSize={lang == 'ta' ? '18px' : '16px'}
                      width={lang == 'ta' ? '290px' : '187px'}
                      fontFamily={
                        lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'
                      }
                      fontWeight={'600'}
                      lineHeight="20px"
                      margin="0"
                      textAlign={lang == 'ta' ? 'left' : 'center'}
                    />
                  </Flex>
                </Box>
              </Box>
              <Box
                pt={{ base: '30.01px', md: '63px', lg: '20px' }}
                width={{ base: '100%', md: '100%', lg: '610px', xl: '610px' }}
                height="407px"
              >
                <LazyLoadImageComponent
                  src={sectionContent[3]?.image?.url}
                  maxW={'624px'}
                />
              </Box>
            </Flex>
          </Box>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box
          m={{ base: '0 auto', md: '40px', lg: '0 auto' }}
          p={{ base:'0 10px', md:'0'}}
          height="auto"
          backgroundColor={'#00052F'}
          display="flex"
          flexDir="column"
        >
          <Box
            height="auto"
            m="0 auto"
            //pb="50px"
            display="grid"
            placeItems="center"
          >
            <Flex
              flexDir={{ base: 'column', md: 'column', lg: 'row' }}
              alignItems="center"
              m={{ base: '35px 4px 0 4px', md: '0 4px', lg: '0' }}
            >
              <Box
                as="article"
                //maxW="540px"
                //mt={{ base: '24px', md: '0' }}
                mr={{ base: '0', md: '0', lg: '54px' }}
              >
                <Heading
                  as="h2"
                  fontStyle="normal"
                  fontWeight="600"
                  fontSize={{
                    base: lang == 'ta' ? '24px' : '38px',
                    sm: lang == 'ta' ? '24px' : '38px',
                    lg: lang == 'ta' ? '32px' : '40px',
                  }}
                  lineHeight={{
                    base: lang == 'ta' ? '28px' : '45.6px',
                    sm: lang == 'ta' ? '28px' : '45.6px',
                    lg: lang == 'ta' ? '32px' : '48px',
                  }}
                  color="#FFA735"
                  fontFamily={
                    lang == 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'
                  }
                >
                  {sectionContent[0].text}
                </Heading>
                <Heading
                  as="h3"
                  fontWeight={lang == 'ta' ? '600' : '500'}
                  fontSize={{
                    base: '24px',
                    sm: '24px',
                    lg: lang == 'ta' ? '32px' : '30px',
                  }}
                  lineHeight={{ base: '22.8px', sm: '22.8px', lg: '28.5px' }}
                  fontFamily={
                    lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-medium'
                  }
                  color={'#FFA735'}
                  mb={'10px'}
                >
                  {sectionContent[1].text}
                </Heading>
                <Box
                  pt={{ base: '30.01px', md: '63px', lg: '20px' }}
                  width={{ base: '100%', md: '100%', lg: '500px', xl: '579px' }}
                >
                  <LazyLoadImageComponent
                    src={sectionContent[3]?.image?.url}
                    //maxW={"624px"}
                  />
                </Box>
                <Text
                  as="p"
                  mt="10px"
                  fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'}
                  className="left-intro-section-textm"
                  mb="-10px"
                >
                  <style>
                    {`
                .left-intro-section-textm{
                  p {
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 21.6px;
                    color: #FFFFFF;
                    margin-bottom:15px;
                    text-align: left;
                  }
                }
                `}
                    .
                  </style>
                  <StructuredTextParser
                    str={render(sectionContent[2].body)}
                    p="0"
                    lang={lang}
                    fontSize="18px"
                    color={'#FFFFFF'}
                    pageName="tamilthembu"
                    fontFamily={
                      lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'
                    }
                  />
                </Text>
                <Box>
                  <Flex
                    flexDir={{ md: 'row', base: 'column' }}
                    mt="20px"
                    alignItems={{
                      base: lang == 'ta' ? 'center' : 'flex-start',
                      md: 'center',
                    }}
                  >
                    <SimpleButton
                      style={sectionContent[4]}
                      region={region}
                      lang={lang}
                      mb="0"
                      mt="0"
                      fontSize="18px"
                      fontFamily={lang == 'ta' ? 'MuktaMalar' : ''}
                      width={lang == 'ta' ? '288px' : ''}
                      lineHeight="20px"
                      heigh={lang == 'ta' ? '76px' : ''}
                      margin="0"
                      fontWeight="600"
                      textAlign={lang == 'ta' ? 'left' : 'center'}
                    />
                  </Flex>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </>
    );
  }
};

export default TwoColumnTextAndImage;
